"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteDomain = exports.DeleteDomain = exports.DeleteDomainActionTypes = exports.addDomain = exports.AddDomain = exports.AddDomainActionTypes = exports.stageRemoveDomain = exports.stageAddDomain = exports.loadDomains = exports.FetchDomains = exports.FetchDomainsActionTypes = exports.DomainsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var DomainsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_DOMAINS: null,
  STAGE_ADD_DOMAIN: null,
  STAGE_REMOVE_DOMAIN: null,
  ADD_DOMAIN: null,
  DELETE_DOMAIN: null
}, 'analytics-and-tracking');
exports.DomainsActionTypes = DomainsActionTypes;
var FetchDomainsActionTypes = (0, _actions.createRequestTypes)(DomainsActionTypes.FETCH_DOMAINS);
exports.FetchDomainsActionTypes = FetchDomainsActionTypes;
var FetchDomains = (0, _actions.createRequestActions)(FetchDomainsActionTypes);
exports.FetchDomains = FetchDomains;
var loadDomains = (0, _fluxActions.createAction)(DomainsActionTypes.FETCH_DOMAINS);
exports.loadDomains = loadDomains;
var stageAddDomain = (0, _fluxActions.createAction)(DomainsActionTypes.STAGE_ADD_DOMAIN, function (domain) {
  return domain;
});
exports.stageAddDomain = stageAddDomain;
var stageRemoveDomain = (0, _fluxActions.createAction)(DomainsActionTypes.STAGE_REMOVE_DOMAIN, function (domain) {
  return domain;
}); //Below actions are fired as a result of saving staged changes, and should not be used manually

exports.stageRemoveDomain = stageRemoveDomain;
var AddDomainActionTypes = (0, _actions.createRequestTypes)(DomainsActionTypes.ADD_DOMAIN);
exports.AddDomainActionTypes = AddDomainActionTypes;
var AddDomain = (0, _actions.createRequestActions)(AddDomainActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.creatingDomain.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.creatingDomain.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DomainsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.AddDomain = AddDomain;
var addDomain = (0, _fluxActions.createAction)(DomainsActionTypes.ADD_DOMAIN, function (domain) {
  return domain;
});
exports.addDomain = addDomain;
var DeleteDomainActionTypes = (0, _actions.createRequestTypes)(DomainsActionTypes.DELETE_DOMAIN);
exports.DeleteDomainActionTypes = DeleteDomainActionTypes;
var DeleteDomain = (0, _actions.createRequestActions)(DeleteDomainActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.deletingDomain.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.deletingDomain.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(DomainsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.DeleteDomain = DeleteDomain;
var deleteDomain = (0, _fluxActions.createAction)(DomainsActionTypes.DELETE_DOMAIN, function (domain) {
  return domain;
});
exports.deleteDomain = deleteDomain;